export const parseSizes = (sizes) => {
  if (!sizes) return [];
  if (Array.isArray(sizes)) return sizes;
  return String(sizes)
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
};

export const parseColors = (colors) => {
  if (!colors) return [];
  if (Array.isArray(colors)) return colors;
  return String(colors)
    .split(",")
    .map((c) => c.trim())
    .filter(Boolean);
};

export const formatHUF = (amount) => {
  return new Intl.NumberFormat('hu-HU', { style: 'currency', currency: 'HUF', maximumFractionDigits: 0 }).format(amount);
};

export const getDisplayPrice = (price, member, tiers = []) => {
  let discount = member?.tier?.shop_discount_percent;
  if (discount === undefined && member?.tier?.id && tiers?.length) {
    const t = tiers.find((x) => x.id == member.tier.id);
    discount = t?.shop_discount_percent ?? 0;
  }
  discount = discount ?? 0;
  if (discount <= 0) return price;
  return Math.max(1, Math.round(price * (100 - discount) / 100));
};
